<template>
	<div class="sp-template">
		<div class="h-title">供应商渠道管理</div>
		<el-card class="box-card">
			<div slot="header" class="clearfix">
				<el-form :inline="true" :model="conditions" class="demo-form-inline" size="small">
					<el-form-item label="渠道名称">
            <el-input v-model="conditions.name" placeholder="请输入名称" clearable></el-input>
					</el-form-item>
          <el-form-item label="供应商">
						<el-select v-model="conditions.supplierId" filterable clearable>
              <el-option v-for="item in suppliers" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
					</el-form-item>
          <el-form-item label="服务类型">
						<el-select v-model="conditions.typeId" filterable clearable>
              <el-option v-for="item in serviceTypes" :key="item.code" :label="item.name" :value="item.code"></el-option>
            </el-select>
					</el-form-item>
          <el-form-item label="状态">
            <el-select v-model="conditions.usable" clearable>
              <el-option v-for="item in statusList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
					</el-form-item>
					<el-form-item>
						<el-button v-if="in_configs(71301)" type="primary" @click="search">搜索</el-button>
					</el-form-item>
				</el-form>
			</div>
      <div class="table-button__groups">
        <div class="button-groups">
          <el-button v-if="in_configs(71302)" size="small" @click="addChannel">添加渠道</el-button>
          <el-button v-if="in_configs(71303)" size="small" @click="addPrice">添加价格</el-button>
        </div>
      </div>
			<el-table ref="multipleTable" v-loading="loading" :data="supplierChannelData" stripe border style="width: 100%" @cell-click="handleCellClick">
				<el-table-column prop="code" label="渠道代码"></el-table-column>
				<el-table-column prop="name" label="渠道名称"></el-table-column>
        <el-table-column prop="typeId" label="服务类型">
          <template slot-scope="scope" >
						{{serviceTypeMap[scope.row.typeId]}}
					</template>
        </el-table-column>
				<el-table-column label="供应商">
          <template slot-scope="scope" >
						{{supplierMap[scope.row.supplierId]}}
					</template>
        </el-table-column>
				<el-table-column label="计费方式">
          <template slot-scope="scope" >
						{{calculationMethodMap[scope.row.calculationMethod]}}
					</template>
        </el-table-column>
				<el-table-column prop="price" label="价格"></el-table-column>
				<el-table-column label="状态">
          <template slot-scope="scope" >
						{{scope.row.usable ? "启用" : "停用"}}
					</template>
        </el-table-column>
         <el-table-column
            label="凭证"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <el-image
                style="width: 100px; height: 100px"
                :src="scope.row.attachmentUrl"
                :preview-src-list="[scope.row.attachmentUrl]"
              >
              </el-image>
            </template>
          </el-table-column>
				<el-table-column prop="modifyDate" label="操作时间"></el-table-column>
				<el-table-column prop="operator" label="操作者"></el-table-column>
				<el-table-column label="操作">
          <template slot-scope="scope" >
            <el-dropdown trigger="click" >
              <el-button plain size="small">...</el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-if="in_configs(71305)" size="mini" type="text" @click.native="editChannel(scope.row)">编辑</el-dropdown-item>
                <el-dropdown-item v-if="in_configs(71304)" size="mini" type="text" @click.native="showHistoricalPrice(scope.row.id)">查看历史价格</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
					</template>
        </el-table-column>
			</el-table>
			<!-- 分页 -->
			<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
			</el-pagination>
      <!-- 添加渠道弹层 -->
			<el-dialog :title="title" :visible.sync="dialogFormVisible" class="fullwidth-form__dialog" width="500px">
				<el-form :model="supplierChannelForm" status-icon :rules="rules" ref="supplierChannelForm" size="small" label-width="80px">
          <el-row>
            <el-col :span="20">
              <el-form-item label="渠道代码"  prop = "code">
                <el-input v-model="supplierChannelForm.code" auto-complete="off" placeholder="渠道代码" clearable></el-input>
              </el-form-item>
              <el-form-item label="渠道名称"  prop = "name">
                <el-input v-model="supplierChannelForm.name" auto-complete="off" placeholder="渠道名" clearable></el-input>
              </el-form-item>
              <el-form-item label="服务类型"  prop = "typeId">
                <el-select v-model="supplierChannelForm.typeId" filterable clearable>
                  <el-option v-for="item in serviceTypes" :key="item.code" :label="item.name" :value="item.code"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="供应商"  prop = "supplierId">
                <el-select v-model="supplierChannelForm.supplierId" filterable clearable>
                  <el-option v-for="item in suppliers" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="supplierChannelForm.id != null && supplierChannelForm.id != ''" label="状态" >
                <el-radio v-model="supplierChannelForm.usable" :label=1>启用</el-radio>
                <el-radio v-model="supplierChannelForm.usable" :label=0>停用</el-radio>
              </el-form-item>
            </el-col>
          </el-row>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button size="small" @click="dialogFormVisible = false">取 消</el-button>
					<el-button size="small" type="primary" @click="submitChannel('supplierChannelForm')">确 定</el-button>
				</div>
			</el-dialog>
      <!-- 添加价格弹层 -->
      <el-dialog title="添加价格" :visible.sync="dialogFormVisible1" class="fullwidth-form__dialog" width="500px">
				<el-form :model="supplierChannelPriceForm" status-icon :rules="rules2" ref="supplierChannelPriceForm" size="small" label-width="80px">
          <el-row>
            <el-col :span="20">
              <el-form-item label="渠道" prop = "channelId">
                <el-select v-model="supplierChannelPriceForm.channelId" filterable clearable>
                  <el-option v-for="item in supplierChannels" :key="item.id" :label="item.code" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="计费方式"  prop = "calculationMethod" >
                <el-select v-model="supplierChannelPriceForm.calculationMethod" filterable clearable>
                  <el-option v-for="item in calculationMethods" :key="item.value" :label="item.name" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="价格"  prop = "price">
                <el-input v-model="supplierChannelPriceForm.price" auto-complete="off" placeholder="价格" clearable></el-input>
              </el-form-item>

              <el-form-item label="上传图片" prop="img">
                <el-upload
                  ref="upload"
                  action="#"
                  accept="image/png,image/gif,image/jpg,image/jpeg"
                  list-type="picture-card"
                  :limit=1
                  :auto-upload="false"
                  :on-change="handleChange"
                  :on-exceed="handleExceed"
                  :before-upload="handleBeforeUpload"
                  :on-preview="handlePictureCardPreview"
                  :on-remove="handleRemove">
                  <i class="el-icon-plus"></i>
                </el-upload>
            </el-form-item>
            </el-col>
          </el-row>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button size="small" @click="dialogFormVisible1 = false">取 消</el-button>
					<el-button size="small" type="primary" @click="submitPrice('supplierChannelPriceForm')">确 定</el-button>
				</div>
			</el-dialog>
      <!-- 查看历史价格弹层 -->
      <el-dialog title="历史价格" :visible.sync="dialogFormVisible2" class="fullwidth-form__dialog" width="800px">
        <el-table ref="multipleTable" :data="priceData" stripe border style="width: 100%" @cell-click="handleCellClick">
          <el-table-column label="计费方式">
            <template slot-scope="scope" >
              {{calculationMethodMap[scope.row.calculationMethod]}}
            </template>
          </el-table-column>
          <el-table-column prop="price" label="价格"></el-table-column>
          <el-table-column label="生效时间">
            <template slot-scope="scope" >
              {{formatDate(new Date(scope.row.effectiveFrom),'yyyy-MM-dd HH:mm:ss')}}
            </template>
          </el-table-column>
          <el-table-column label="失效时间">
            <template slot-scope="scope" >
              {{formatDate(new Date(scope.row.effectiveTo),'yyyy-MM-dd HH:mm:ss')}}
            </template>
          </el-table-column>
           <el-table-column
            label="凭证"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <el-image
                style="width: 100px; height: 100px"
                :src="scope.row.attachmentUrl"
                :preview-src-list="[scope.row.attachmentUrl]"
              >
              </el-image>
            </template>
          </el-table-column>
        </el-table>
				<div slot="footer" class="dialog-footer">
					<el-button size="small" @click="dialogFormVisible2 = false">返回</el-button>
				</div>
			</el-dialog>
		</el-card>
	</div>
</template>
<script>
export default {
  data() {
    var checkDuplicateMsg = (rule, value, callback) => {
      if (value) {
        this.$request1({
          method: 'GET',
          url: '/system/supplier-channel-check-code',
          params: {
            id: this.supplierChannelForm.id,
            code: this.supplierChannelForm.code
          }
        })
          .then(response => {
            if (!response.data.success) {
              callback(new Error("渠道编码已存在！"));
            } else {
              callback();
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    };
    return {
      title: "添加渠道",
      srcListtf: [],
      suppliers: [],
      serviceTypes: [],
      supplierChannels: [],
      supplierMap: {},
      serviceTypeMap: {},
      conditions: {
        name: "",
        supplierId: "",
        typeId: "",
        usable: ""
      },
      statusList: [
        {
          id: 1,
          name: "启用"
        },
        {
          id: 0,
          name: "停用"
        }
      ],
      calculationMethods: [
        {
          value: "CONSTANT",
          name: "固定费用"
        },
        {
          value: "WEIGHT_UNIT_PRICE",
          name: "重量*单价"
        },
        {
          value: "VOLUME_UNIT_PRICE",
          name: "体积*单价"
        }
      ],
      calculationMethodMap: {
        CONSTANT: "固定费用",
        WEIGHT_UNIT_PRICE: "重量*单价",
        VOLUME_UNIT_PRICE: "体积*单价"
      },
      supplierChannelData: [],
      priceData: [],
      supplierChannelForm: {
        id: "",
        code: "",
        name: "",
        typeId: "",
        supplierId: "",
        usable: 1
      },
      supplierChannelPriceForm: {
        channelId: "",
        calculationMethod: "",
        price: "",
        img: ""
      },
      rules: {
        code: [
          { required: true, message: "请输入渠道代码", trigger: "blur" },
          { validator: checkDuplicateMsg, trigger: "blur" }
        ],
        name: [{ required: true, message: "请输入渠道名称", trigger: "blur" }],
        typeId: [
          { required: true, message: "请选择服务类型", trigger: "change" }
        ],
        supplierId: [
          { required: true, message: "请选择供应商", trigger: "change" }
        ]
      },
      rules2: {
        channelId: [
          { required: true, message: "请选择渠道", trigger: "change" }
        ],
        calculationMethod: [
          { required: true, message: "请选择计费方式", trigger: "change" }
        ],
        price: [
          { required: true, message: "请输入价格", trigger: "blur" },
          {
            pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/,
            message: "金额只能为数字，最多保留两位小数，并且不能小于零",
            trigger: "blur"
          }
        ],
        img: [
          { required: true, message: "请添加报价凭证", trigger: "change" }
        ]
      },
      img:"",
      total: 1, //总条数
      currentPage: 1, //当前页
      pageSize: 10, //当前显示条数
      pageSizes: [10, 20, 50, 100], //显示条数
      dialogFormVisible: false,
      dialogFormVisible1: false,
      dialogFormVisible2: false,
      loading: true
    };
  },
  created() {
    setTimeout(() => {
      this.loading = false;
      this.querySupplier();
      this.queryServiceType();
      this.query();
    }, 1000);
  },
  methods: {
    //搜索
    search() {
      this.currentPage = 1;
      this.query();
    },
    //加载数据
    query() {
      this.$request1({
        method: 'GET',
        url: '/system/supplier-channel',
        params: {
          name: this.conditions.name,
          supplierId: this.conditions.supplierId,
          typeId: this.conditions.typeId,
          usable: this.conditions.usable,
          currentPage: this.currentPage,
          pageSize: this.pageSize
        }
      })
        .then(response => {
          if (response.data.success) {
            this.supplierChannelData = response.data.data;
            this.total = response.data.total;
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 查看历史价格
    showHistoricalPrice(id) {
      this.$request1({
        method: 'GET',
        url: '/system/supplier-channel-query-price',
        params: {
          channelId: id
        }
      })
        .then(response => {
          if (response.data.success) {
            this.priceData = response.data.data;
            this.dialogFormVisible2 = true;
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(error => {
          this.$message.error("操作失败");
        });
    },
    // 添加渠道
    addChannel() {
      this.title = "添加渠道";
      this.supplierChannelForm.id = "";
      this.supplierChannelForm.code = "";
      this.supplierChannelForm.name = "";
      this.supplierChannelForm.typeId = "";
      this.supplierChannelForm.supplierId = "";
      this.supplierChannelForm.usable = 1;
      this.dialogFormVisible = true;
    },
    // 编辑渠道
    editChannel(row) {
      this.title = "编辑渠道";
      this.supplierChannelForm.id = row.id;
      this.supplierChannelForm.code = row.code;
      this.supplierChannelForm.name = row.name;
      this.supplierChannelForm.typeId = parseInt(row.typeId);
      this.supplierChannelForm.supplierId = row.supplierId;
      this.dialogFormVisible = true;
    },
    // 添加价格
    addPrice(index, row) {
      this.querySupplierChannel();
      this.dialogFormVisible1 = true;
      this.supplierChannelPriceForm.channelId = "";
      this.supplierChannelPriceForm.calculationMethod = "";
      this.supplierChannelPriceForm.price = "";
    },
    // 提交渠道信息
    submitChannel(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$request1({
            method: 'post',
            url: '/system/supplier-channel',
            data: this.supplierChannelForm
          })
            .then(response => {
              if (response.data.success) {
                this.$message({
                  message: "成功",
                  type: "success"
                });
                this.dialogFormVisible = false;
                this.query();
              } else {
                this.$message.error(response.data.message);
              }
            })
            .catch(error => {
              this.$message.error("操作失败");
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 提交价格信息
    submitPrice(formName) {
      let _this=this;
      this.$refs[formName].validate(valid => {
        if (valid) {
          var formData = new FormData();
          for (var key in _this.supplierChannelPriceForm) {
            formData.append(key, _this.supplierChannelPriceForm[key] ? _this.supplierChannelPriceForm[key] : '');
          } 
          this.$request1({
            method: 'post',
            url: '/system/supplier-channel-price',
            data : formData
          })
            .then(response => {
              if (response.data.success) {
                this.$message({
                  message: "成功",
                  type: "success"
                });
                this.dialogFormVisible1 = false;
                this.query();
              } else {
                this.$message.error(response.data.message);
              }
            })
            .catch(error => {
              this.$message.error("操作失败");
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //分页
    handleSizeChange(pageSize) {
      this.currentPage = 1;
      this.pageSize = pageSize;
      this.query();
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.query();
    },
    // 供应商名称
    querySupplier() {
      this.$request1({
        method: 'GET',
        url: '/supplier'
      })
        .then(response => {
          this.suppliers = response.data;
          if (this.suppliers != null && this.suppliers.length > 0) {
            this.suppliers.forEach(item => {
              this.supplierMap[item.id] = item.name;
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 服务类型
    queryServiceType() {
      this.$request1({
        method: 'GET',
        url: '/system/map/supplier-service-type'
      })
        .then(response => {
          this.serviceTypes = response.data;
          if (this.serviceTypes != null && this.serviceTypes.length > 0) {
            this.serviceTypes.forEach(item => {
              this.serviceTypeMap[item.code] = item.name;
            });
          }
        })
        .catch(error => {
          this.$message.error("操作失败");
        });
    },
    // 供应商渠道
    querySupplierChannel() {
      this.$request1({
        method: 'GET',
        url: '/system/supplier-all-usable-channel'
      })
        .then(response => {
          this.supplierChannels = response.data;
        })
        .catch(error => {
          this.$message.error("操作失败");
        });
    },
    formatDate(date, fmt) {
      if (!date) {
        return "";
      }
      var o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours() % 12 == 0 ? 12 : date.getHours() % 12, //小时
        "H+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        S: date.getMilliseconds() //毫秒
      };
      var week = {
        "0": "/u65e5",
        "1": "/u4e00",
        "2": "/u4e8c",
        "3": "/u4e09",
        "4": "/u56db",
        "5": "/u4e94",
        "6": "/u516d"
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }
      if (/(E+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (RegExp.$1.length > 1
            ? RegExp.$1.length > 2
              ? "/u661f/u671f"
              : "/u5468"
            : "") + week[date.getDay() + ""]
        );
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
        }
      }
      return fmt;
    },
    handleChange(file, fileList) {
      if (file.raw.size > 1024 * 1024 * 10) {
        this.$message.error("单张照片限制最大10M");
        this.fileList = [];
      } else {
        this.supplierChannelPriceForm.img = file.raw;
      }
    },
    // 文件超出个数限制时的钩子
    handleExceed(files, fileList) {
      this.$notify.warning({
        title: "提示",
        message: "只能上传一张图片！"
      });
    },
    // 文件列表移除文件时的钩子
    handleRemove(file, fileList) {
      this.supplierChannelPriceForm.img = null;
    },
     // 上传文件之前的钩子
    handleBeforeUpload(file) {
      if (
        !(
          file.type === "image/png" ||
          file.type === "image/gif" ||
          file.type === "image/jpg" ||
          file.type === "image/jpeg"
        )
      ) {
        this.$notify.warning({
          title: "提示",
          message:
            "请上传格式为image/png, image/gif, image/jpg, image/jpeg的图片"
        });
      }
      let size = file.size / 1024 / 1024 / 2;
      if (size > 2) {
        this.$notify.warning({
          title: "提示",
          message: "图片大小必须小于2M"
        });
      }
    },
    // 点击文件列表中已上传的文件时的钩子
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //点击图片显示大图
    handleCellClick(row, column, cell, event) {
      if (event.target.className === "el-image") {
        event.target.__vue__.showViewer = true;
      }
    },
  }
};
</script>
<style lang="scss" scoped>
.box-card {
  margin: 20px -10px;
}
</style>


// WEBPACK FOOTER //
// src/views/system/supplierchannel.vue